/* eslint-disable no-unused-vars */
import { Button, InputField } from '@synergy-marine-group/synergy-ui';
import CreatableSelect from 'react-select/creatable';
import React, { useEffect } from 'react';
import Modal from 'react-responsive-modal';
import showAlert from '../../utils/alert';
import { mailModalStyles } from './styles';

const MailModal = ({
    mailModal,
    setMailModal,
    handleMail,
    cancelMail,
    currencyList,
    vesselList,
    isCrewPage,
    mailBasicInfo,
    setmailBasicInfo, formValues,
    filteredVendorList
}) => {
    const [vendor, setVendor] = React.useState('');
    const ValidateEmail = (mail) => {
        let isValid = true;
        const emailPattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
        if (new RegExp(emailPattern).test(mail)) {
            isValid = true;
        } else {
            isValid = false;
        }
        return isValid;
    };
    useEffect(() => {
    const vendorMail = filteredVendorList?.find((
        { id }
) => id === formValues?.vendorId)?.vendorMail;
const vendorNameUpdate = filteredVendorList?.find((
    { id }
) => id === formValues?.vendorId)?.vendorName;
setVendor(vendorNameUpdate);
    if (vendorMail !== null) {
        if (ValidateEmail(vendorMail)) {
        setmailBasicInfo({ ...mailBasicInfo, to: [vendorMail] });
        } else {
            showAlert('Vendor Mail is invalid', 'error');
        }
    }
    }, []);

    const onChangeMail = (allMail, newItem) => {
        if (newItem.action !== 'create-option' || ValidateEmail(newItem.option.label)) {
            const newMail = allMail.map((mails) => mails.label);
            setmailBasicInfo({ ...mailBasicInfo, to: newMail });
        } else {
            showAlert('Please enter valid mail', 'error');
        }
    };
    const onChangeMailcc = (allMail, newItem) => {
        if (newItem.action !== 'create-option' || ValidateEmail(newItem.option.label)) {
            const newMail = allMail.map((mails) => mails.label);
            setmailBasicInfo({ ...mailBasicInfo, cc: newMail });
        } else {
            showAlert('Please enter valid mail', 'error');
        }
    };
const headerClass = 'w-1/4 font-semibold px-1';
const cellClass = 'w-1/4 px-1';

const renderHeader = () => (
  <div className="flex mt-5">
    {isCrewPage ? (
      <>
        <div className={headerClass}>Crew Code</div>
        <div className={headerClass}>Crew Name</div>
      </>
    ) : (
      <>
        <div className={headerClass}>Vessel Name</div>
        <div className={headerClass}>Vessel Code</div>
      </>
    )}
    <div className={headerClass}>Vendor Name</div>
    <div className={headerClass}>Total Amount</div>
  </div>
);

const renderRow = (item) => {
  const matchedVessel = vesselList?.find(
    (v) => v.id === item.plannedVesselId || v.id === formValues?.plannedVesselId
  );
  const vesselName = matchedVessel?.name ?? formValues?.vesselName
    ?? item?.vesselName ?? item?.plannedVesselName ?? '-';
  const vesselCode = matchedVessel?.vesselCode ?? formValues?.vesselCode
    ?? item?.vesselCode ?? item?.plannedVesselCode ?? '-';
  const currencyLabel = currencyList?.find((c) => c.id === formValues.currencyId)?.label;
  const fullName = `${item.firstName || ''} ${item.lastName || ''}`.trim();

  return (
    <div className="flex mt-4 w-auto h-auto" style={{ wordBreak: 'break-word' }} key={item.crewCode || matchedVessel?.id}>
      {isCrewPage ? (
        <>
          <div className={`${cellClass} uppercase`}>{item.crewCode}</div>
          <div className={cellClass}>{fullName}</div>
        </>
      ) : (
        <>
          <div className={`${cellClass} uppercase`}>{vesselName}</div>
          <div className={cellClass}>{vesselCode}</div>
        </>
      )}
      <div className={cellClass}>{vendor}</div>
      <div className={cellClass}>
        {currencyLabel}
        {' '}
        {item?.airfareStatus === 1 ? '-' : ''}
        {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.amount)}
      </div>
    </div>
  );
};
    return (
        <div className="custom-modal">
            <Modal
                open={mailModal}
                onClose={() => {
                    setMailModal(false);
                }}
                closeOnOverlayClick={false}
                center
                showCloseIcon={false}
                styles={mailModalStyles}
            >

                    <div className="flex flex-col border-none p-2">
                        <div className="uppercase pb-4 text-center text-lg font-bold">Send PO</div>
                        <div className="flex items-center">
                            <label className="font-semibold pr-2">To:</label>
                            <CreatableSelect
                            isMulti
                             placeholder="To"
                             isClearable={false}
                             className="email-input w-full"
                            onChange={onChangeMail}
                            value={mailBasicInfo?.to?.map((item) => ({ label: item, value: item }))}
                            />
                        </div>
                        <hr />
                        <div className="mt-4 flex items-center">
                            <label className="font-semibold pr-2">Cc:</label>
                            <CreatableSelect
                            isMulti
                            className="email-input w-full"
                             placeholder="Cc"
                             isClearable={false}
                            onChange={onChangeMailcc}
                            value={mailBasicInfo?.cc?.map((item) => ({ label: item, value: item }))}
                            />
                        </div>
                        <hr />
                            <div className=" mt-4 flex items-center">
                                <label className="font-semibold pr-2">Subject:</label>
                                <InputField
                                    name="subject"
                                    type="text"
                                    className="w-full add-expense-input email-subject"
                                    id="number"
                                    value={mailBasicInfo?.subject}
                                    size="large"
                                    variant="text"
                                    placeholder="Subject"
                                    onChange={(e) => {
                                        setmailBasicInfo({
                                            ...mailBasicInfo,
                                            subject: e.target.value
                                        });
                                    }}
                                />
                            </div>
                        <hr />
                            <div className=" flex items-center mt-4">
                            <input
                                type="checkbox"
                                checked={mailBasicInfo?.isCustomSubject}
                                className="mr-2"
                                onChange={(e) => {
                                setmailBasicInfo({
                                    ...mailBasicInfo,
                                    isCustomSubject: e.target.checked
                                });
                            }}
                            />
                            <label>Display PO Number in Email subject header</label>
                            </div>
                    </div>
                    {renderHeader()}
                    {formValues?.purchaseOrderCrew?.map(renderRow)}

                        <div className="flex flex-row float-right mt-4">
                            <div className="table-cell p-2">
                                <Button
                                    type="cancel"
                                    size="large"
                                    variant="outlined"
                                    rounded
                                    className="w-36"
                                    onClick={cancelMail}
                                >
                                    Cancel
                                </Button>
                            </div>
                            <div className="table-cell p-2">
                                <Button
                                    type="submit"
                                    size="large"
                                    variant="primary"
                                    rounded
                                    className="w-36"
                                    onClick={handleMail}
                                >
                                    Send
                                </Button>
                            </div>
                        </div>
            </Modal>

        </div>
    );
};

export default MailModal;
